import * as React from "react";
import { useNavigate } from "react-router";
import {
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Stack,
  CircularProgress,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState } from "react";
import { motion } from "motion/react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import boy from "../assets/student.png";
import girl from "../assets/girl.png";
import jewellery from "../assets/jewellery.png";
import man from "../assets/man.png";
import women from "../assets/women.png";

function TopCategories() {
  let navigate = useNavigate();
  const [catData, setCatData] = useState([]);
  const [loading, setLoading] = useState(false);

  // function SampleNextArrow({ onClick }) {
  //   return (
  //     <div className="custom-next-arrow" onClick={onClick}>
  //       <FontAwesomeIcon icon={faAngleRight} />
  //     </div>
  //   );
  // }

  // function SamplePrevArrow({ onClick }) {
  //   return (
  //     <div className="custom-prev-arrow" onClick={onClick}>
  //       <FontAwesomeIcon icon={faAngleLeft} />
  //     </div>
  //   );
  // }
  // const settings = {
  //   dots: false,
  //   infinite: false,
  //   speed: 500,
  //   lazyLoad: true,
  //   slidesToShow: 6,
  //   slidesToScroll: 1,
  //   initialSlide: 0,
  //   swipeToSlide: true,
  //   // centerMode: true,
  //   mobileFirst: true, // Important
  //   nextArrow: <SampleNextArrow />,
  //   prevArrow: <SamplePrevArrow />,
  //   responsive: [
  //     {
  //       breakpoint: 1280,
  //       settings: {
  //         slidesToShow: 6,
  //         centerMode: true,
  //       },
  //     },
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3,
  //         centerMode: true,
  //       },
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 3,
  //       },
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 2,
  //       },
  //     },
  //   ],
  // };

  async function getTopCategory() {
    setLoading(true);

    let url = new URL(
      "https://thesoyara.com/app/index.php?r=api/category-list"
    );
    try {
      let response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      let result = await response.json();
      if (result?.length > 0) {
        setCatData(result);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getTopCategory();
  }, []);

  const imageMap = {
    Mens: man,
    Womens: women,
    Jewellery: jewellery,
    "Boy- Kids": boy,
    "Girls- Kids": girl,
  };

  return (
    <div className="category-section">
      <h2 className="category-title">Our Categories</h2>
      <div className="slider-wrapper">
        <div className="slider-container">
          {/* <Slider {...settings}> */}
          {loading ? (
            <Stack
              // key={index}
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ width: "100%", height: "100px" }}
            >
              {/* <CircularProgress /> */}
              <DotLottieReact
                src="https://lottie.host/e5599654-39d1-4cac-aef5-1c2c4a5af8ca/bTMlPQbvw8.lottie"
                loop
                autoplay
                style={{ width: "60px", height: "60px" }}
              />
            </Stack>
          ) : (
            catData.map((item, index) => {
              const imgSrc = imageMap[item.name];
              return (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <Card
                    className="category-card"
                    onClick={() => navigate(`/product_list/${item.id}`)}
                  >
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        image={imgSrc}
                        className="category-img"
                        alt={item.name}
                      />
                      <CardContent className="category-card-content">
                        <h5 className="category-name">{item.name}</h5>
                        {/* <p className="browse-text">Browse Now</p> */}
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </motion.div>
              );
            })
          )}
          {/* </Slider> */}
        </div>
      </div>
    </div>

    // <div className="category-section">
    //   <div className="slider-container">
    //     <h3 className="category-title">Our Categories</h3>
    //     <Slider {...settings}>
    //       {catData.map(function (item, index) {
    //         return loading ? (
    //           <Stack
    //             direction="row"
    //             justifyContent="center"
    //             alignItems="center"
    //             style={{ width: "100%",height:'100%' }}
    //             key={item.id}
    //           >
    //             <CircularProgress />
    //           </Stack>
    //         ) : (
    //           <Card className="category-card" onClick={()=> navigate(`/product_list/${item.id}`)}  key={item.id}>
    //             <CardActionArea>
    //               <CardMedia
    //                 component="img"
    //                 // image={item.img}
    //                 className="category-img"
    //               />
    //               <CardContent className="category-card-content">
    //                 <h5 className="catogory-title">{item.name}</h5>
    //               </CardContent>
    //             </CardActionArea>
    //           </Card>
    //         );
    //       })}
    //     </Slider>
    //   </div>
    // </div>
  );
}
export default TopCategories;
